import type { TocItem } from './SettingsTableOfContents';

/**
 * Slugify a string to produce a URL-friendly id.
 * This is the same algorithm used by SettingsSection to auto-generate section ids.
 */
function slugify(text: string): string {
	return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

/**
 * Create a TocItem from a section title. The id is derived via slugify, which
 * matches the auto-generated id that SettingsSection produces from its title prop.
 * Using this helper prevents silent mismatches between TOC ids and section ids.
 */
export function createTocItem(title: string): TocItem {
	return { id: slugify(title), title };
}
